/**
 * Генерация slug для URL из названия предмета
 * Должна соответствовать логике на бэкенде
 */

/** Пять износов CS2 — закрытый список (parity с parsing.py WEARS). */
const WEARS = new Set([
  'Factory New',
  'Minimal Wear',
  'Field-Tested',
  'Well-Worn',
  'Battle-Scarred',
]);

export function parseMarketHashName(fullName: string): {
  weapon: string;
  skin: string;
  wear: string;
  is_stattrak: boolean;
  is_souvenir: boolean;
} {
  const result = {
    weapon: '',
    skin: '',
    wear: '',
    is_stattrak: false,
    is_souvenir: false,
  };

  if (!fullName) return result;

  let name = fullName.trim();

  // StatTrak
  if (name.includes('StatTrak™')) {
    result.is_stattrak = true;
    name = name.replace('StatTrak™ ', '');
  }

  // Souvenir
  if (name.includes('Souvenir')) {
    result.is_souvenir = true;
    name = name.replace('Souvenir ', '');
  }

  // Wear (в скобках в конце)
  // Зеркалит backend/src/modules/catalog/parsing.py: скобочный суффикс —
  // износ только если это один из пяти реальных износов CS2. Иначе туда
  // попадала отделка стикеров («Sticker | Luck Skill (Foil)» → wear='Foil'),
  // и slug склеивал разные предметы в одну карточку.
  const wearMatch = name.match(/\(([^)]+)\)$/);
  if (wearMatch && WEARS.has(wearMatch[1].trim())) {
    result.wear = wearMatch[1].trim();
    name = name.slice(0, wearMatch.index).trim();
  }

  // Weapon | Skin
  if (name.includes('|')) {
    const parts = name.split('|');
    result.weapon = parts[0].trim();
    result.skin = parts[1].trim();
  } else {
    result.weapon = name;
  }

  return result;
}

export function generateSlug(
  weapon: string, 
  skin: string, 
  isStattrak: boolean = false, 
  isSouvenir: boolean = false,
  wear: string = ''
): string {
  // Добавляем префикс для уникальности
  let prefix = '';
  if (isStattrak) {
    prefix = 'stattrak-';
  } else if (isSouvenir) {
    prefix = 'souvenir-';
  }
  
  let text: string;
  if (skin) {
    text = `${prefix}${weapon}-${skin}`;
  } else if (wear) {
    // Для предметов без skin (стикеры, кейсы) добавляем wear
    text = `${prefix}${weapon}-${wear}`;
  } else {
    text = `${prefix}${weapon}`;
  }
  
  let slug = text
    .toLowerCase()
    .replace(/[^\w\s-]/g, '-')
    .replace(/[\s]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
  
  // Защита от пустого slug
  if (!slug) {
    slug = 'item';
  }
  
  return slug;
}

export function getCanonicalMarketHashName(parsed: ReturnType<typeof parseMarketHashName>): string {
  let prefix = '';
  if (parsed.is_stattrak) prefix = 'StatTrak™ ';
  else if (parsed.is_souvenir) prefix = 'Souvenir ';
  
  if (parsed.skin) {
    return `${prefix}${parsed.weapon} | ${parsed.skin}`;
  }
  return `${prefix}${parsed.weapon}`;
}

export function getSlugFromItemName(fullName: string): string {
  const parsed = parseMarketHashName(fullName);
  return generateSlug(parsed.weapon, parsed.skin, parsed.is_stattrak, parsed.is_souvenir, parsed.wear);
}
